export var level1 = {
  id: '1',
  name: 'First level',
  rank: 1
};
export var level2 = {
  id: '2',
  name: 'Third level',
  rank: 3
};
export var level3 = {
  id: '3',
  name: 'Second level',
  rank: 2
};